export const header_submenu_animation : any = {
    animate : {
        height     : "0",
        overflow   : "hidden",
        display    : "flex",
        transition : {
            type     : "tween",
            duration : 0.35,
            ease     : "easeInOut",
        }, 
    },
  
    hover : {
        height     : "auto",
        display    : "flex",
        transition : {
            type     : "tween",
            duration : 0.35,
            ease     : "easeInOut",
        },
    },
};